/**
 * Go Honey — Dynamic Variant Content Swap (v8)
 * ==============================================
 */

(function () {
  'use strict';

  var dataEl = document.getElementById('variant-content-data');
  if (!dataEl) return;

  var variantData;
  try {
    variantData = JSON.parse(dataEl.textContent).variants;
  } catch (e) {
    console.error('[GoHoney] Failed to parse variant content data:', e);
    return;
  }

  // ── Inject CSS once ────────────────────────────────────────────────
  if (!document.getElementById('gh-variant-swap-styles')) {
    var style = document.createElement('style');
    style.id = 'gh-variant-swap-styles';
    style.textContent =
      '.rj-features { --rj-accent: #fec34d; --rj-text: #403b38; margin: 10px 0; }' +
      '.rj-item { display: flex; align-items: flex-start; margin: 8px 0; }' +
      '.rj-icon { width: 18px; height: 18px; min-width: 18px; margin-right: 8px; margin-top: 2px; }' +
      '.rj-text { color: #403b38; font-size: 14px; line-height: 1.6; }' +
      '.gh-desc { color: #403b38; line-height: 1.6; }' +
      '.gh-desc p { margin: 0 0 12px 0; }' +
      '.gh-desc__best-for-label { font-weight: 600; margin: 16px 0 8px 0; font-size: 14px; }' +
      '.gh-desc__grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 24px; }' +
      '@media (max-width: 480px) { .gh-desc__grid { grid-template-columns: 1fr; } }' +
      '.gh-desc__grid-item { display: flex; align-items: center; gap: 6px; font-size: 14px; }' +
      '.gh-desc__grid-icon { width: 18px; height: 18px; min-width: 18px; }';
    document.head.appendChild(style);
  }

  var FADE_MS = 200;

  var RJ_SVG = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="rj-icon">' +
    '<rect style="fill: var(--rj-accent);" rx="9" height="18" width="18" y="3" x="3"></rect>' +
    '<polyline style="fill: none; stroke: var(--rj-text); stroke-linecap: round; stroke-linejoin: round; stroke-width:1.5;" points="8 11.5 11 14.5 16 9.5"></polyline>' +
    '<rect style="fill: none; stroke: var(--rj-text); stroke-linecap: round; stroke-linejoin: round; stroke-width:1.5;" rx="9" height="18" width="18" y="3" x="3"></rect>' +
    '</svg>';

  var GRID_SVG = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="gh-desc__grid-icon">' +
    '<rect style="fill: #fec34d;" rx="9" height="18" width="18" y="3" x="3"></rect>' +
    '<polyline style="fill: none; stroke: #403b38; stroke-linecap: round; stroke-linejoin: round; stroke-width:1.5;" points="8 11.5 11 14.5 16 9.5"></polyline>' +
    '<rect style="fill: none; stroke: #403b38; stroke-linecap: round; stroke-linejoin: round; stroke-width:1.5;" rx="9" height="18" width="18" y="3" x="3"></rect>' +
    '</svg>';

  function extractLines(html) {
    var text = html
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<\/li>/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, ' ');
    return text.split('\n').map(function (l) { return l.trim(); }).filter(function (l) { return l.length > 0; });
  }

  function toDescription(html) {
    if (!html || html === 'null' || html === '') return html;
    var lines = extractLines(html);
    if (lines.length === 0) return html;
    var introLines = [], bestForItems = [], foundBestFor = false;
    lines.forEach(function (line) {
      if (line.match(/^Best\s*For\s*:?\s*$/i)) { foundBestFor = true; return; }
      if (!foundBestFor) { introLines.push(line); }
      else {
        var item = line.replace(/^[\u2022\u2023\u25E6\u2043\u2219\u25CF•◈\-–—·]\s*/, '').trim();
        if (item) bestForItems.push(item);
      }
    });
    if (!foundBestFor) return '<div class="gh-desc"><p>' + introLines.join('</p><p>') + '</p></div>';
    var output = '<div class="gh-desc">';
    if (introLines.length > 0) output += '<p>' + introLines.join(' ') + '</p>';
    if (bestForItems.length > 0) {
      output += '<div class="gh-desc__best-for-label">Best For:</div><div class="gh-desc__grid">';
      bestForItems.forEach(function (item) { output += '<div class="gh-desc__grid-item">' + GRID_SVG + ' ' + item + '</div>'; });
      output += '</div>';
    }
    return output + '</div>';
  }

  function toRjFeatures(html) {
    if (!html || html === 'null' || html === '') return html;
    var lines = extractLines(html);
    var items = [];
    lines.forEach(function (line) {
      var text = line.replace(/^[\u2022\u2023\u25E6\u2043\u2219\u25CF•\-–—·]\s*/, '').trim();
      if (text) items.push(text);
    });
    if (items.length === 0) return html;
    var output = '<div class="rj-features">';
    items.forEach(function (item) { output += '<div class="rj-item">' + RJ_SVG + ' <span class="rj-text">' + item + '</span></div>'; });
    return output + '</div>';
  }

  // ── Find target elements ───────────────────────────────────────────
  function findDescriptionEl() {
    var block = document.querySelector('.product-single__box__block--description');
    if (!block) return null;
    return block.querySelector('.product-single__accordion__item-wrap') || block.querySelector('.rte') || null;
  }

  function findAccordionByTitle(titleText) {
    var summaries = document.querySelectorAll('.product-single details summary h3');
    for (var i = 0; i < summaries.length; i++) {
      if (summaries[i].textContent.trim().toLowerCase() === titleText.toLowerCase()) {
        var details = summaries[i].closest('details');
        if (details) return details.querySelector('.product-single__accordion__item-wrap') || details.querySelector('details-content');
      }
    }
    return null;
  }

  function findByHeadingPrefix(prefix) {
    var section = document.querySelector('.product-single');
    if (!section) return null;
    var headings = section.querySelectorAll('h2, h3, h4, h5');
    for (var i = 0; i < headings.length; i++) {
      if (headings[i].textContent.trim().toLowerCase().indexOf(prefix.toLowerCase()) === 0) return headings[i];
    }
    return null;
  }

  var targets = {};
  function cacheTargets() {
    targets.description = findDescriptionEl();
    targets.whyHeading = findByHeadingPrefix('Why Manuka Honey');
    targets.ingredients = findAccordionByTitle('Ingredients');
    targets.tasteNotes = findAccordionByTitle('Taste Notes');
    targets.dosageUse = findAccordionByTitle('Dosage & Use');
  }

  function fadeSwap(el, content, textOnly) {
    if (!el || !content || content === 'null' || content === '') return;
    el.style.transition = 'opacity ' + FADE_MS + 'ms ease';
    el.style.opacity = '0';
    setTimeout(function () {
      if (textOnly) el.textContent = content; else el.innerHTML = content;
      el.style.opacity = '1';
    }, FADE_MS);
  }

  function instantSwap(el, content, textOnly) {
    if (!el || !content || content === 'null' || content === '') return;
    if (textOnly) el.textContent = content; else el.innerHTML = content;
  }

  // ── Core swap (with strict duplicate guard) ────────────────────────
  var lastSwappedId = null;

  function doSwap(variantId, immediate) {
    var vid = String(variantId);
    if (vid === lastSwappedId) return;
    lastSwappedId = vid;

    var data = variantData[vid];
    if (!data) return;

    cacheTargets();
    var swap = immediate ? instantSwap : fadeSwap;

    if (data.description) swap(targets.description, toDescription(data.description), false);
    if (data.whyTitle && targets.whyHeading) swap(targets.whyHeading, data.whyTitle, true);

    if (data.whyBullets && targets.whyHeading) {
      var whyBlock = targets.whyHeading.closest('.product-single__box__block') || targets.whyHeading.closest('details-content');
      if (whyBlock) {
        var rjContainer = whyBlock.querySelector('.rj-features');
        var styled = toRjFeatures(data.whyBullets);
        if (rjContainer) {
          swap(rjContainer, styled, false);
        } else {
          var els = whyBlock.querySelectorAll('.rte, ul, ol, .block-callout__text, .rj-features');
          for (var i = 0; i < els.length; i++) {
            if (!els[i].contains(targets.whyHeading)) { swap(els[i], styled, false); break; }
          }
        }
      }
    }

    if (data.ingredients) swap(targets.ingredients, toRjFeatures(data.ingredients), false);
    if (data.tasteNotes) swap(targets.tasteNotes, data.tasteNotes, false);
    if (data.dosageUse) swap(targets.dosageUse, data.dosageUse, false);
  }

  // ── Single detection method: watch the ONE hidden input in the form ─
  function setupVariantWatch() {
    // Find the primary product form
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    if (!form) form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var hiddenInput = form.querySelector('input[name="id"][type="hidden"]');
    if (!hiddenInput) return;

    // Watch only this one input
    new MutationObserver(function () {
      if (hiddenInput.value) {
        doSwap(hiddenInput.value, false);
      }
    }).observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

    // Return current value for init
    return hiddenInput.value;
  }

  // ── Initialize ─────────────────────────────────────────────────────
  function init() {
    var currentId = setupVariantWatch();

    // Also check URL
    var params = new URLSearchParams(window.location.search);
    var urlVariant = params.get('variant');
    if (urlVariant) currentId = urlVariant;

    // Do initial swap
    if (currentId && variantData[String(currentId)]) {
      doSwap(currentId, true);
    }
  }

  if (document.readyState === 'complete') {
    setTimeout(init, 300);
  } else {
    window.addEventListener('load', function () { setTimeout(init, 300); });
  }
})();